import { render, staticRenderFns } from "./SYBuyListView.vue?vue&type=template&id=6e2eb498&scoped=true&"
import script from "./SYBuyListView.vue?vue&type=script&lang=js&"
export * from "./SYBuyListView.vue?vue&type=script&lang=js&"
import style0 from "./SYBuyListView.vue?vue&type=style&index=0&id=6e2eb498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2eb498",
  null
  
)

export default component.exports